import UnitDetailCard from '@AMIEWEB/Order/OrderCreationForm/Common/UnitDetailCard';
import { Grid, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ScheduleSubSection } from './ScheduleSubSection';
import PlacementTerms from './PlacementTerms';
import TechnologyInformation from './TechnologyInformation';
import AdditionalRequiredQualifications from '@AMIEWEB/Order/OrderCreationForm/Components/UnitDetail/UnitDetails/AdditionalRequiredQualifications';
import PreferredQualifications from '@AMIEWEB/Order/OrderCreationForm/Components/UnitDetail/UnitDetails/PreferredQualifications';
import InternalNotes from '@AMIEWEB/Order/OrderCreationForm/Components/UnitDetail/UnitDetails/InternalNotes';
import { FormPageType } from '@AMIEWEB/Order/OrderCreationForm/Components/UnitDetail/UnitRequirements/Experience/SubCertificate/SubCertificate.types';
import ExternalJobDescriptionContainer from '../OrderRequirements/ExternalJobDescription';
import { selectPage3DefaultValues } from '@AMIEWEB/NewOrder/Store/Order.selectors';
import { useDispatch, useSelector } from 'react-redux';
import { orderCreationNewActions } from '@AMIEWEB/NewOrder/Store/OrderCreation.actions';

const OrderDetails = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const arePage3DefaultValuesSet = useSelector(selectPage3DefaultValues);

  useEffect(() => {
    if (!arePage3DefaultValuesSet) dispatch(orderCreationNewActions.setDefaultFreeTextValuesPage3());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container spacing={4} sx={{ mt: '0px', pl: '11px' }}>
      <Grid xs={12} sx={{ paddingLeft: '24px', marginTop: '10px' }}>
        <Typography
          variant="h6"
          sx={{
            font: 'normal normal normal 20px/26px Roboto',
            color: theme => theme.palette.system.darkGray,
            letterSpacing: '0px',
          }}
        >
          {t('order.newOrderCreation.tabs.orderDetails')}
        </Typography>
      </Grid>
      <Grid item xs={12} sx={{ paddingTop: '12px !important' }}>
        <UnitDetailCard
          title={t('order.newOrderCreation.tabs.schedule')}
          children={<ScheduleSubSection />}
          hasSubSection={true}
        />
      </Grid>
      <Grid item xs={12} sm={6} paddingBottom={6}>
        <UnitDetailCard title={t('order.newOrderCreation.tabs.placementTerms')} minHeight={'100%'} children={<PlacementTerms />} />
      </Grid>
      <Grid item xs={12} sm={6} paddingBottom={6}>
        <UnitDetailCard
          title={t('order.newOrderCreation.tabs.technologyInformation')}
          children={<TechnologyInformation />}
        />
      </Grid>
      <Grid item xs={12} paddingBottom={6}>
        <UnitDetailCard
          title={t('order.newOrderCreation.tabs.additionRequirements')}
          children={<AdditionalRequiredQualifications parentPage={FormPageType.Order} />}
        />
      </Grid>
      <Grid item xs={12} paddingBottom={6}>
        <UnitDetailCard
          title={t('order.newOrderCreation.tabs.preferredQualification')}
          children={<PreferredQualifications parentPage={FormPageType.Order} />}
        />
      </Grid>
      <Grid item xs={12} paddingBottom={6}>
        <UnitDetailCard
          title={t('order.newOrderCreation.tabs.internalNotes')}
          children={<InternalNotes parentPage={FormPageType.Order} />}
        />
      </Grid>
      <Grid item xs={12} paddingBottom={6}>
        <UnitDetailCard
          title={t('order.newOrderCreation.tabs.externalJobDescription')}
          children={<ExternalJobDescriptionContainer />}
        />
      </Grid>
    </Grid>
  );
};

export default OrderDetails;
